import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

import { SharedModuleData } from "../../../gql";

const SharedModulesTableSharedFromCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleData>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{sharedModule.ownerSubdomain}</TableCellText>
    </TableSimpleCell>
  );
};

export default SharedModulesTableSharedFromCell;
